import { microBrand } from './brand';
/** Explicitly opted-in action buttons only; never applied to nav, hold or icon buttons. */
export const actionMotionStyles = {
    '&:focus-visible': { outline: `2px solid ${microBrand.focus}`, outlineOffset: '3px' },
    '@media (prefers-reduced-motion: no-preference) and (hover: hover) and (pointer: fine)': {
        transition: 'transform 160ms ease-out',
        '&:not(:disabled):not(.Mui-disabled):not(:focus-visible):hover': { transform: 'translateY(-2px)' },
        '&:not(:disabled):not(.Mui-disabled):not(:focus-visible):active': { transform: 'translateY(0)' }
    },
    '@media (prefers-reduced-motion: reduce)': { transition: 'none', transform: 'none' },
    '@media (forced-colors: active)': { '&:focus-visible': { outlineColor: 'Highlight' } }
};
